import { HelpCircle } from "lucide-react";
import { Link } from "react-router-dom";

const PAGE_INFO = {
  dashboard: {
    title: "Dashboard",
    description: "Your financial overview at a glance. See your total balance, account distribution, and recent activity.",
  },
  accounts: {
    title: "Accounts",
    description: "Manage all your savings and investment accounts. Set the balance, currency, and expected annual return for each account.",
  },
  investments: {
    title: "Investments",
    description: "Define the asset allocation for each investment account across equity, debt, commodities, cash, crypto and property.",
  },
  monthly: {
    title: "Monthly Budget",
    description: "Set your typical monthly income, expenses, and savings. Monthly Savings will be used in Future Planning calculations.",
  },
  annual: {
    title: "Annual Budget",
    description: "Track annual income (bonus, dividends) and expenses (insurance, school fees). Net Balance × 12 from Monthly Budget is automatically included.",
  },
  planning: {
    title: "Future Planning",
    description: "Create financial forecasts based on your accounts, savings, and expected returns. Visualize your wealth growth over time.",
  },
  holidays: {
    title: "Holiday Planning",
    description: "Plan and budget your vacations year by year. Track estimated costs vs actual spending for travel, accommodation, food, and more.",
  },
  allocations: {
    title: "Investment Allocations",
    description: "Track your monthly investment allocations by instrument type (stocks, ETFs, bonds, etc.).",
  },
  settings: {
    title: "Settings",
    description: "Configure your default currency and other preferences.",
  },
  help: {
    title: "Help & Guide",
    description: "Learn how to use LifeLedger effectively with step-by-step guides and frequently asked questions.",
  },
};

export default function PageHeader({ pageKey }) {
  const info = PAGE_INFO[pageKey] || { title: "Page", description: "" };
  
  return (
    <div className="flex items-start justify-between mb-6">
      <div>
        <h1 className="text-2xl font-bold text-white mb-1">{info.title}</h1>
        <p className="text-gray-400 text-sm max-w-2xl">{info.description}</p>
      </div>
      <Link 
        to="/help" 
        className="flex items-center gap-1 text-gray-500 hover:text-green-400 transition-colors text-sm"
      >
        <HelpCircle className="w-4 h-4" />
        <span className="hidden sm:inline">Help</span>
      </Link>
    </div>
  );
}

export { PAGE_INFO };
